import React from 'react';
import { Flipbook } from './view/flipbook';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'FlipBook',
  itemElt: (item, cmsOption) => <Flipbook item={item} cmsOption={cmsOption} />
}
